export const PRODUCT_NAME = "WildLark"
export const PRODUCT_ID = "wildlark"
export const WILDLARK_TOOL_PREFIX = `${PRODUCT_ID}_`
export const TASK_TOOL_PREFIX = `${WILDLARK_TOOL_PREFIX}task_`
export const PROCESS_TOOL_PREFIX = `${WILDLARK_TOOL_PREFIX}process_`
export const BROWSER_TOOL_PREFIX = `${WILDLARK_TOOL_PREFIX}browser_`

export const TASK_TOOL_NAMES = {
    scheduleFollowup: `${TASK_TOOL_PREFIX}schedule_followup`,
    listFollowups: `${TASK_TOOL_PREFIX}list_followups`,
    listSessions: `${TASK_TOOL_PREFIX}list_sessions`,
    startSession: `${TASK_TOOL_PREFIX}start_session`,
    waitSession: `${TASK_TOOL_PREFIX}wait_session`,
    readSession: `${TASK_TOOL_PREFIX}read_session`,
    setWorkingDirectory: `${TASK_TOOL_PREFIX}set_working_directory`,
    linkPR: `${TASK_TOOL_PREFIX}link_pr`,
    unlinkPR: `${TASK_TOOL_PREFIX}unlink_pr`,
    readPR: `${TASK_TOOL_PREFIX}read_pr`,
    wakeOnPRChange: `${TASK_TOOL_PREFIX}wake_on_pr_change`,
    setPRAutomation: `${TASK_TOOL_PREFIX}watch_pr`,
    completePRDelivery: `${TASK_TOOL_PREFIX}complete_pr_delivery`,
    sleepTask: `${TASK_TOOL_PREFIX}sleep`,
    wakeTask: `${TASK_TOOL_PREFIX}wake`,
    closeTask: `${TASK_TOOL_PREFIX}close`,
} as const

export const PROCESS_TOOL_NAMES = {
    list: `${PROCESS_TOOL_PREFIX}list`,
    stop: `${PROCESS_TOOL_PREFIX}stop`,
} as const

export const BROWSER_TOOL_NAMES = {
    start: `${BROWSER_TOOL_PREFIX}start`,
    requestUserAction: `${BROWSER_TOOL_PREFIX}request_user_action`,
    tabs: `${BROWSER_TOOL_PREFIX}tabs`,
    navigate: `${BROWSER_TOOL_PREFIX}navigate`,
    readPage: `${BROWSER_TOOL_PREFIX}read_page`,
    extractContent: `${BROWSER_TOOL_PREFIX}extract_content`,
    find: `${BROWSER_TOOL_PREFIX}find`,
    screenshot: `${BROWSER_TOOL_PREFIX}screenshot`,
    click: `${BROWSER_TOOL_PREFIX}click`,
    hover: `${BROWSER_TOOL_PREFIX}hover`,
    type: `${BROWSER_TOOL_PREFIX}type`,
    select: `${BROWSER_TOOL_PREFIX}select`,
    scroll: `${BROWSER_TOOL_PREFIX}scroll`,
    press: `${BROWSER_TOOL_PREFIX}press`,
    drag: `${BROWSER_TOOL_PREFIX}drag`,
    batch: `${BROWSER_TOOL_PREFIX}batch`,
} as const
